import { render, staticRenderFns } from "./DeviceProfiles.vue?vue&type=template&id=53d06eed&"
import script from "./DeviceProfiles.vue?vue&type=script&lang=js&"
export * from "./DeviceProfiles.vue?vue&type=script&lang=js&"
import style0 from "./DeviceProfiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports